module.exports = __webpack_public_path__ + "img/cup-shop-logo-192x192.a14cdd52.png";